import { Chain } from '@ankr.com/chains-list';
import { Plus } from '@ankr.com/ui';

import { AccountPermission } from 'modules/permissions/constants';
import { ChainProjectsSidebar } from 'modules/chains/components/ChainProjectsSidebar';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { useChainsProjects } from 'modules/chains/hooks/useChainsProjects';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { ChainMenuItem } from '../ChainMenuItem';
import { addToProjectMenuItemTranslation } from './translation';

interface AddToProjectMenuItemProps {
  chain: Chain;
  closeMenu: () => void;
}

export const AddToProjectMenuItem = ({
  chain,
  closeMenu,
}: AddToProjectMenuItemProps) => {
  const { projects, projectsWithChains } = useChainsProjects();

  const {
    isOpened: isOpenedAddToProjectsSidebar,
    onClose: onCloseAddToProjectsSidebar,
    onOpen: handleAddToProjectsDialogOpen,
  } = useDialog();

  const { keys, t } = useTranslation(addToProjectMenuItemTranslation);

  const onClick = () => {
    closeMenu();

    handleAddToProjectsDialogOpen();
  };

  return (
    <GuardAccountPermission permission={AccountPermission.JwtManagerRead}>
      <ChainMenuItem onClick={onClick} Icon={Plus}>
        {t(keys.addToProject)}
      </ChainMenuItem>
      <ChainProjectsSidebar
        chain={chain}
        isOpenedAddToProjectsSidebar={isOpenedAddToProjectsSidebar}
        projects={projects}
        onCloseAddToProjectsSidebar={onCloseAddToProjectsSidebar}
        projectsWithBlockchains={projectsWithChains}
      />
    </GuardAccountPermission>
  );
};
